// extracted by mini-css-extract-plugin
module.exports = {"default":"SuperRadio_default__3lH7T"};